import { render, staticRenderFns } from "./PoolSimpleTable.vue?vue&type=template&id=4fc037c1"
import script from "./PoolSimpleTable.vue?vue&type=script&lang=js"
export * from "./PoolSimpleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports